import React from 'react';
import PropTypes from 'prop-types';
import { ErrorOutline as ErrorOutlineIcon } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';

import { Container } from './style';
import Theme from '../../../../../constants/theme';

const Incident = ({ original }) => {
  const { incident } = original;

  return (
    <Container>
      {incident && (
      <Tooltip title={`Incident ${incident.delivery && incident.delivery.code}`} placement="top">
        <ErrorOutlineIcon style={{ color: Theme.orangeLight }} />
      </Tooltip>
      )}
    </Container>
  );
};

Incident.propTypes = {
  original: PropTypes.shape({
    incident: PropTypes.shape({
      delivery: PropTypes.shape({
        code: PropTypes.string,
      }),
    }),
  }),
};

Incident.defaultProps = {
  original: {},
};

export default Incident;
